import * as am5 from "@amcharts/amcharts5";
import { ENGINE_CHART_TYPE } from "../../constants/trendGraph/enginesLine";
import { GRAPH_TYPE } from "../../constants/trendGraph/trendGraphType";
import { ELECTRIC_TREND_TYPE } from "../../constants/trendGraph/electricLines";

const getLineInfo = ({ vesselData, dataList, chartType, isComparison, type }) => {
  if (isComparison) {
    if (
      chartType === ENGINE_CHART_TYPE.ENGINE_DEVIATION ||
      chartType === ENGINE_CHART_TYPE.ENGINE_EXHAUST ||
      chartType === ENGINE_CHART_TYPE.ENGINE_TEMP
    ) {
      return filterDatalistByCylinders(dataList, vesselData);
    } else if (type === GRAPH_TYPE.ELECTRIC && chartType === ELECTRIC_TREND_TYPE.ELECTRIC_POWER_TREND) {
      return filterDataListByGenerator(dataList, vesselData).filter(
        (d) => d.name !== "dateTime" && d.name !== "localDateTime" && d.key !== "dateTime"
      );
    } else {
      return (
        dataList?.filter(
          (d) => d.name !== "dateTime" && d.name !== "localDateTime" && d.key !== "dateTime"
        ) ?? []
      );
    }
  } else {
    if (
      chartType === ENGINE_CHART_TYPE.ENGINE_DEVIATION ||
      chartType === ENGINE_CHART_TYPE.ENGINE_EXHAUST ||
      chartType === ENGINE_CHART_TYPE.ENGINE_TEMP
    ) {
      return filterDatalistByCylinders(dataList, vesselData);
    } else if (type === GRAPH_TYPE.ELECTRIC && chartType === ELECTRIC_TREND_TYPE.ELECTRIC_POWER_TREND) {
      return filterDataListByGenerator(dataList, vesselData).filter(
        (d) => d.name !== "dateTime" && d.name !== "localDateTime" && d.key !== "dateTime"
      );
    } else {
      return (
        dataList?.filter(
          (d) => d.name !== "dateTime" && d.name !== "localDateTime" && d.key !== "dateTime"
        ) ?? []
      );
    }
  }
};
const filterDatalistByCylinders = (dataList, vesselData) => {
  if (!vesselData) return [];
  //fetch number of cylinders by vessel id
  const cylinders = vesselData.cylinder;
  const MEEngineType = vesselData.MEEngineType;
  // If MEEngineType is S, remove B type cylinders
  if (MEEngineType === "S") {
    dataList = dataList?.filter((d) => !d.name.includes("B"));
  }
  //Filter the datalist according to the number of cylinders
  const filteredDataItems = dataList?.filter(
    (d) =>
      !(
        d.name === "dateTime" ||
        d.name === "localDateTime" ||
        d.key === "dateTime" ||
        d.name.match(/\d+/)?.[0] > cylinders
      )
  );
  return filteredDataItems;
};

const filterDataListByGenerator = (dataList, vesselData) => {
  if (!vesselData) return [];
  const filteredDataItems = dataList?.filter(
    (d) =>
      (d.keyName.match(/sg\d/)?.length > 0 &&
        d.keyName.match(/sg\d/)?.[0].substr(-1) <= vesselData.NoSG) ||
      (d.keyName.match(/dg\d/)?.length > 0 &&
        d.keyName.match(/dg\d/)?.[0].substr(-1) <= vesselData.NoDG)
  );
  return filteredDataItems;
};


const LockTooltip = (chart, isGantt, isClickedChart) => {
  const cursor = chart.get("cursor");
  const cursorX = cursor.getPrivate("positionX");
  const cursorY = cursor.getPrivate("positionY");

  if(!isGantt && !isClickedChart) {
    chart.yAxes.values[0].set("tooltip", am5.Tooltip.new(chart.root, {
      forceHidden: true
    }));
  }

  cursor.setAll({
    positionX: cursorX,
    positionY: cursorY,
    alwaysShow: true,
  });

  chart.plotContainer
    .setAll({
      tooltipPosition: "fixed",
      tooltipX: chart.plotContainer.width() * cursorX,
      tooltipY: chart.plotContainer.height() * cursorY,
      showTooltipOn: "always",
    });

  chart.plotContainer
    .getTooltip()
    .get("background")
    .setAll({
      fill: am5.color(0x27303d),
      stroke: am5.color(0xfea813),
    });

  cursor.lineX.setAll({
    stroke: am5.color(0xfea813),
    strokeWidth: 2,
    strokeDasharray: [],
  });

  cursor.lineY.setAll({
    stroke: am5.color(0xfea813),
    strokeWidth: 2,
    strokeDasharray: [],
  });

  setChartInteraction(chart, true, false);
  setCursorInteraction(chart, false, isGantt);
}

const UnlockTooltip = (chart, isGantt) => {
  const cursor = chart.get("cursor");
  chart.plotContainer.setAll({
    tooltipPosition: "pointer",
    showTooltipOn: "hover",
  });

  if(!isGantt) {
    chart.yAxes.values[0].set("tooltip", am5.Tooltip.new(chart.root, {
      forceHidden: false
    }));
  }

  cursor.setAll({
    positionX: null,
    positionY: null,
    alwaysShow: false,
  });

  chart.plotContainer.getTooltip().hide();
  chart.plotContainer
    .getTooltip()
    .get("background")
    .setAll({
      fill: am5.color(0x27303d),
      stroke: am5.color(0xffffff),
    });

  cursor.lineX.setAll({
    stroke: am5.color(0xffffff),
    strokeWidth: 2,
    strokeDasharray: [],
  });

  cursor.lineY.setAll({
    stroke: am5.color(0xffffff),
    strokeWidth: 2,
    strokeDasharray: [],
  });

  setChartInteraction(chart, false, true);
  setCursorInteraction(chart, true, isGantt);
}

// Disable zooming and panning when the tooltip is locked
const setChartInteraction = (chart, isLocked, interactive) => {
  chart.set("wheelY", isLocked ? interactive : "zoomX");
  chart.plotContainer.set("clickable", interactive);
};

// Disable cursor interactions when the tooltip is locked
const setCursorInteraction = (chart, interactive, isGantt = false) => {
  chart.get("cursor").setAll({
    behavior: interactive ? isGantt ? "zoomX" : "zoomXY" : "none",
    lineX: { strokeOpacity: interactive ? 1 : 0 },
    lineY: { strokeOpacity: interactive && !isGantt ? 1 : 0 },
  });
};

//lock tooltip handle function
const handleTooltipLock = (chType, charts) => {
  charts.map((chart, i) => LockTooltip(chart, i === 1, chType === i));
};

const handleTooltipUnlocking = (charts) => {
  charts.map((chart, i) => UnlockTooltip(chart, i === 1));
};

export { getLineInfo, handleTooltipLock, handleTooltipUnlocking }